import { selectBuildingsInfoByTypeId } from "../../../../../selectors/selectExistingBuildingInfo";
import { createPathFocusBuildingMaxLevel } from "../../../path/createPathFocusBuildingMaxLevel";
export var pathFocusBuildingMaxLevelOfType = function (action, state$, deps) {
    return createPathFocusBuildingMaxLevel(function () {
        var state = state$.value;
        return selectBuildingsInfoByTypeId(state, action.taskType.buildingId);
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/have-building/paths/pathFocusBuildingMaxLevelOfType.ts
// module id = 2377
// module chunks = 3